import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box, CircularProgress, Alert } from '@mui/material';
import { apiService } from '../services/api';

const GenericPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!slug) return;
    const fetchPage = async () => {
      try {
        setLoading(true);
        const res = await apiService.getPage(slug);
        if (res?.page) {
          setPage(res.page);
        } else {
          setError('Page not found');
        }
      } catch (e) {
        setError('Page not found');
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, [slug]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (error || !page) {
    return (
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Alert severity="error">{error || 'Page not found'}</Alert>
      </Container>
    );
  }

  const hasHero = page.hero_title || page.hero_subtitle || page.hero_image;

  return (
    <Box>
      {hasHero && (
        <Box
          sx={{
            background: page.hero_image
              ? `linear-gradient(135deg, rgba(29,29,78,0.9) 0%, rgba(26,34,126,0.85) 100%), url(${page.hero_image}) center/cover`
              : 'linear-gradient(135deg, #1D1D4E 0%, #1a237e 100%)',
            color: 'white',
            py: 8,
            textAlign: 'center',
          }}
        >
          <Container maxWidth="lg">
            {page.hero_title && (
              <Typography variant="h1" sx={{ fontSize: { xs: '2rem', md: '3rem' }, fontWeight: 700, mb: 2 }}>
                {page.hero_title}
              </Typography>
            )}
            {page.hero_subtitle && (
              <Typography variant="h6" sx={{ opacity: 0.9, maxWidth: 640, mx: 'auto' }}>
                {page.hero_subtitle}
              </Typography>
            )}
          </Container>
        </Box>
      )}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        {!hasHero && page.page_title && (
          <Typography variant="h1" gutterBottom sx={{ fontSize: '2.5rem', fontWeight: 700, color: 'primary.main' }}>
            {page.page_title}
          </Typography>
        )}
        {page.page_content && (
          <Box
            component="div"
            sx={{
              '& h2': { mt: 4, mb: 2 },
              '& p': { mb: 2 },
              '& ul, & ol': { pl: 4, mb: 2 },
            }}
            dangerouslySetInnerHTML={{ __html: page.page_content }}
          />
        )}
        {!page.page_content && (
          <Typography color="text.secondary">No content for this page yet.</Typography>
        )}
      </Container>
    </Box>
  );
};

export default GenericPage;
